import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

import AOS from 'aos';

$(document).ready(function() {

	// animations on scroll
	AOS.init();

	// masonry grid for galleries
	$('.masonry-gallery').each(function() {
		const $gallery = $(this);
		imagesLoaded(this, function() {
			new Masonry($gallery[0], {
				itemSelector: '.gallery-item'
			});
		});
	});

	// modal pop up for gallery images
	var $g_modal = $('#gallery-modal');
	$('.gallery-link').click(function(e){

		// cancel click/link
		e.preventDefault();

		// reset modal
		$g_modal.find('img').remove();

		// clone the thumbnail image for immediate loading
		var $temp = $(this).find('img').clone();
		$temp.appendTo($g_modal.find('.modal-content'));
		$g_modal.modal('show');

		// swap for the full size image once preloaded
		var img = new Image();
		var img_url = $(this).attr('data-src');
		img.onload = function() {
			$g_modal.find('img').attr('src', img_url);
			console.log('full size image rendered.');
		};
		img.src = img_url;

	});

	// contact forms
	var $form = $('form#contact');
	$form.submit(function(e) {

		e.preventDefault();

		var $errors = $form.find('.form-errors');
		var $btn = $form.find('button[type="submit"]');

		if ($btn.hasClass('disabled')) return;

		$btn.addClass('disabled').html('Sending...');
		$errors.html('').addClass('d-none');

		$.post({
			url: '/',
			dataType: 'json',
			data: $(this).serialize(),
			success: function(response) {
				$form.remove();
				$('.form-success').removeClass('d-none');
			},
			error: function(jqXHR) {
				$errors.html(jqXHR.responseJSON.message).removeClass('d-none');
				$btn.html('Send Message').removeClass('disabled');
			}
		});
	});

});
